<div class="cald_dialog preview-data-table">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{ 'FormulaBuilder_TablePreviewDialogHeader' | translate }}</h2>
  </div>
  <div class="cald_content">
    <div class="preview-table-wrapper cpq-scroll">
      @if (isInit) {
        <cpq-datatable
          #dataTable id="dataTable"
          [rows]='previewTableData'
          [columns]="columns"
          [filter]='filter'
          [serverSideProcessing]="false"
          [guid]="guid"
          [showColumnSearchFields]="true">
        </cpq-datatable>
      }
    </div>
  </div>
  <div class="form-inline cald_dialog_buttonbar flex-center">
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" id="cancel" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>